<template>
  <table class="table table-borderless table-border table-align">
    <thead>
      <tr>
        <th>
          <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow"/>
        </th>
        <th>Protocolo</th>
        <th>Placa</th>
        <th>Renavam</th>
        <th>CNPJ</th>
        <th>Status do veículo</th>
        <th>Status do Cronotacógrafo</th>
        <th>GRU</th>
        <th>Documento</th>
        <th>Status (documento)</th>
        <th>Emitido em</th>
        <th>Data de vencimento</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="chronotachograph in chronotachographs" :key="chronotachograph.id">
        <td>
          <BkpsCheckBox v-model="chronotachograph.checked" @input="$emit('changeCheckRow', $event)"/>
        </td>
        <td>{{ chronotachograph.protocol }}</td>
        <td>{{ chronotachograph.plate }}</td>
        <td>{{ chronotachograph.renavam }}</td>
        <td>{{ chronotachograph.cnpj | cnpj }}</td>
        <td>{{ vehicleStatusLabel(chronotachograph) }}</td>
        <td>{{ situationLabel(chronotachograph) }}</td>
        <td>{{ chronotachograph.gruNumber }}</td>
        <td>{{ chronotachograph.documentNumber }}</td>
        <td>{{ chronotachograph.documentStatus }}</td>
        <td>{{ chronotachograph.issuedAt | date }}</td>
        <td>{{ chronotachograph.validAt | date }}</td>
        <td>{{ chronotachograph.updatedAt | datetime }}</td>
        <td>
          <router-link :to="`/cm-crono/cronotacografo/${chronotachograph.id}`">
            <button  class="btn btn-primary mr-2">Detalhes</button>
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import GetAccount from '@/mixins/GetAccount.vue'
import GetUser from '@/mixins/GetUser'
import GlobalLoading from '@/mixins/GlobalLoading'
import { vehicleStatusRowLabel } from '@/utils/vehicleStatus'
import { cronoEffectiveSituation, cronoSituationLabel } from '@/utils/cronoSituation'

export default {
  components: { BkpsCheckBox },
  mixins: [GetUser, GetAccount, GlobalLoading],
  name: 'Table',
  props: {
    checkAllRow: { required: true, type: Boolean },
    chronotachographs: { required: true, type: Array },
    entityStatusNames: { type: Object, default: () => ({}) }
  },
  data: () => ({
  }),
  methods: {
    vehicleStatusLabel(chronotachograph) {
      return vehicleStatusRowLabel(chronotachograph, this.entityStatusNames)
    },
    situationLabel(chronotachograph) {
      return cronoSituationLabel(cronoEffectiveSituation(chronotachograph))
    },
    openLoad() {
      this.openGlobalLoad()
    },
    closeLoad() {
      this.closeGlobalLoad()
    },
  },
}
</script>

<style scoped>
.color-badge {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  border-radius: 3px;
}
</style>
